module.exports = __webpack_public_path__ + "static/media/like.416a7f6f.webp";